module.exports = __webpack_public_path__ + "img/siteweb.65537d0c.png";